import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {ICarInstallsStatistic, ICarStatusesStatistic, ICurrentStatistic} from "../../../../services/statistic.service";

@Component({
  selector: 'app-cars-current-statistics',
  templateUrl: './cars-current-statistics.component.html',
  styleUrls: ['./cars-current-statistics.component.scss']
})
export class CarsCurrentStatisticsComponent implements OnInit {
  @Input() data: ICurrentStatistic;
  carInstalls: ICarInstallsStatistic;
  carStatuses: ICarStatusesStatistic;
  @Input() inputAction$: EventEmitter<any> = new EventEmitter<any>();
  carInstallsOption;
  carStatusesOption;

  constructor() { }

  ngOnInit(): void {
    this.carInstalls = this.data.carInstalls;
    this.carStatuses = this.data.carStatuses;
    this.setData();
    this.inputAction$.subscribe(value => {
      this.carInstalls = value.carInstalls;
      this.carStatuses = value.carStatuses;
      this.setData();
    })
  }

  setData() {
    let carInstallsOption = {
      legend: {
        show: true,
        y: 'bottom',
        textStyle: {
          fontSize: '15',
        },
      },
      series: [
        {
          name: 'Data',
          data: [],
          type: 'pie',
          radius: [50, 130],
          label: {
            show: true,
            position: 'center',
            fontSize: '22',
            formatter: this.getCarInstallsAll()
          },
          color: ['#0d8f25', '#ad0606'],
        }
      ]
    };
    if (this.carInstalls.all !== 0) {
      carInstallsOption.series[0].data = [
        {value: this.carInstalls.installedCount, name: this.getLabel('installed')},
        {value: this.carInstalls.notInstalledCount, name: this.getLabel('notInstalled')}
      ];
    } else {
      carInstallsOption.series[0].data = [{value: 0, name: 'All: 0'}];
      carInstallsOption.series[0].color = ['#5A6870ED'];
    }

    this.carInstallsOption = carInstallsOption;


    let carStatusesOption = {
      legend: {
        show: true,
        y: 'bottom',
        textStyle: {
          fontSize: '15',
        },
      },
      series: [
        {
          name: 'Data',
          data: [],
          type: 'pie',
          radius: [50, 130],
          labelLine: {
            show: false,
          },
          label: {
            show: true,
            position: 'center',
            fontSize: '22',
            formatter: this.getCarStatusesAll()
          },
          color: ['#0d8f25', '#ad0606', '#ffd904', '#616161']
        },
      ]
    };
    if (this.carStatuses.all !== 0) {
      carStatusesOption.series[0].data = [
        {value: this.carStatuses.ok, name: this.getLabel('ok')},
        {value: this.carStatuses.alerted, name: this.getLabel('alerted')},
        {value: this.carStatuses.warned, name: this.getLabel('warned')},
        {value: this.carStatuses.inactive, name: this.getLabel('inactive')},
      ];
    } else {
      carStatusesOption.series[0].data = [{value: 0, name: 'All: 0'}];
      carStatusesOption.series[0].color = ['#5A6870ED'];
    }

    this.carStatusesOption = carStatusesOption;
  }

  getLabel(field) {
    let label = '';
    switch (field) {
      case 'installed': {
        label = 'Installed: ' + this.carInstalls.installedCount  + ' / ' +
          +(this.carInstalls.installedCount*100 / this.carInstalls.all).toFixed(2) + '%'
        break;
      }
      case 'notInstalled': {
        label = 'Not installed: ' + this.carInstalls.notInstalledCount  + ' / ' +
          +(this.carInstalls.notInstalledCount*100 / this.carInstalls.all).toFixed(2) + '%'
        break;
      }
      case 'ok': {
        label = 'OK: ' + this.carStatuses.ok  + ' / ' +
          +(this.carStatuses.ok*100 / this.carStatuses.all).toFixed(2) + '%'
        break;
      }
      case 'alerted': {
        label = 'Alerted: ' + this.carStatuses.alerted  + ' / ' +
          +(this.carStatuses.alerted*100 / this.carStatuses.all).toFixed(2) + '%'
        break;
      }
      case 'warned': {
        label = 'Warned: ' + this.carStatuses.warned  + ' / ' +
          +(this.carStatuses.warned*100 / this.carStatuses.all).toFixed(2) + '%'
        break;
      }
      case 'inactive': {
        label = 'Inactive: ' + this.carStatuses.inactive  + ' / ' +
          +(this.carStatuses.inactive*100/ this.carStatuses.all).toFixed(2) + '%'
        break;
      }
    }
    if (label.split('/')[0].trim() === '0') label = null;
    return label;
  }

  getCarInstallsAll() {
    return this.carInstalls.all.toString();
  }

  getCarStatusesAll() {
    return this.carStatuses.all.toString();
  }
}
